import styled from 'styled-components';

export const Template = styled.div`
   
`;

export const PageContainer = styled.div`
    max-width:1000px;
    margin:auto;
`;

export const PageTitle = styled.h1`
    font-size:27px;
    color:#ff2018;
`;

export const PageBody = styled.div``;

export const ErrorMessage = styled.div`
    margin:10px 0;
    background-color:#fff0c7;
    color:#000;
    border:2px solid #ff2018;
    padding:10px;
`;


export const SucessoMessage = styled.div`
    margin:10px 0;
    background-color:#fff4c2;
    color:#000;
    border:2px solid #ffcc00;
    padding:10px;
`;